import {Partecipant} from "src/app/classes/common/partecipant";
import {Poi} from "src/app/classes/common/poi";
import {Waypoint} from "src/app/classes/common/waypoint";

export class PlanRoute {

  _id: string;
  name: string;
  timestamp_create: number;
  timestamp_update: number;
  private _waypoints: Waypoint[] = [];
  private _$google_url: string;
  starred: boolean = false;

  private $getParticipant: (id: string) => Partecipant = () => {return undefined};
  private $getPoi: (id: string) => Poi = () => {return undefined};

  constructor(data?: any,options? : {
    getParticipant?: (id: string) => Partecipant,
    getPoi?: (id: string) => Poi,
  }){
    if(data){
      this.setData(data, options);
    }
  }

  setData(data:any, options?: {
    getParticipant?: (id: string) => Partecipant,
    getPoi?: (id: string) => Poi,
  }) {
    if(data){
      if(options){
        if(options.getParticipant) this.$getParticipant = options.getParticipant
        if(options.getPoi) this.$getPoi = options.getPoi
      }
      this._id = data._id.toString();
      this.name = data.name;
      this.timestamp_create = data.timestamp_create;
      this.timestamp_update = data.timestamp_update;
      this.waypoints = data.waypoints;
      this.starred = data.starred;
      this.$google_url = '';
    }
  }

  get waypoints(): Waypoint[]{
    return this._waypoints;
  }

  set waypoints(value: any){
    this._waypoints = [];
    if(value.length > 0){
      for(let i = 0; i < value.length; i++){
        const waypoint: any = {
          type: value[i].type,
          coordinates: value[i].coordinates,
        };
        switch(value[i].type){
          case 'poi':
            waypoint.poi = this.$getPoi(value[i].entity_id);
            break;
          case 'participant':
            waypoint.partecipant = this.$getParticipant(value[i].entity_id);
            break;
          case 'address':
            waypoint.data = value[i].address;
            break;
        }
        this._waypoints.push(new Waypoint(waypoint))
      }
    }
  }


  get $google_url(): string{
    return this._$google_url;
  }

  set $google_url(value: string){
    let i: number = this.waypoints.length - 1;
    if(!this.waypoints.length || !this.waypoints[i].hasCoordinates){
      this._$google_url = undefined
      return;
    }
    let res: string = 'https://www.google.com/maps/dir/?api=1&origin=' +
      this.waypoints[0].coordinates.latitude + ',' + this.waypoints[0].coordinates.longitude +
      "&destination=" + this.waypoints[i].coordinates.latitude + ',' + this.waypoints[i].coordinates.longitude;

    if (this.waypoints.length > 2) {
      res += '&waypoints=';

      for (i = 1; i < this.waypoints.length - 1; i++) {
        res += this.waypoints[i].coordinates.latitude + ',' + this.waypoints[i].coordinates.longitude + "|";
      }

      res = res.slice(0, -1);
      res+='&trevelmode=driving'
    }

    this._$google_url = res || undefined;
  }





}
